import { render, staticRenderFns } from "./ProjectTemplateDetail.vue?vue&type=template&id=18102aeb&scoped=true&"
import script from "./ProjectTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplateDetail.vue?vue&type=style&index=0&id=18102aeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18102aeb",
  null
  
)

export default component.exports